import { render, staticRenderFns } from "./AS_PressRelease.vue?vue&type=template&id=13fda67c&scoped=true&"
import script from "./AS_PressRelease.vue?vue&type=script&lang=js&"
export * from "./AS_PressRelease.vue?vue&type=script&lang=js&"
import style0 from "./AS_PressRelease.vue?vue&type=style&index=0&id=13fda67c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fda67c",
  null
  
)

export default component.exports